/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./categorizerRuleInput.scss');
require('ui-select');

const deps = [
  require('angular-ui-router'),
  require('data/user').name,
  require('data/collection/ledger').name,
  require('data/collection/categorizerRule').name,
  require('data/model/categorizerRule').name,
  require('ui/web/confirmDialog').name,
  require('ui/web/notifications').name,
  'ui.select',
  'ngFileUpload',
];

module.exports = angular
  .module('bench.ui.categorizerRuleInput', deps)

  .directive('blCategorizerRuleInput', () => ({
    restrict: 'E',
    scope: {
      rulesId: '@',
      ruleId: '=',
    },
    bindToController: true,
    template: require('./categorizerRuleInput.html'),
    controller: require('./categorizerRuleInputCtrl.js'),
    controllerAs: 'vm',
  }));
